import { MutableRefObject, useRef } from 'react';
import Player from 'video.js/dist/types/player';

interface UseVideoRetryOptions {
    playerRef: MutableRefObject<Player | null>;
    videoSrc: string;
    onFail: () => void;
    type: string;
}

export const useVideoRetry = ({
    playerRef,
    videoSrc,
    onFail,
    type,
}: UseVideoRetryOptions) => {
    const ERROR_MAX_RETRIES = 60;
    const ERROR_DEFAULT_TIMEOUT_RETRY = 5000;
    const ERROR_FIRST_TIMEOUT_RETRY = 2000;

    const errorRetries = useRef(0);

    const handleRetryOnSrcError = () => {
        const player = playerRef.current;

        if (errorRetries.current < ERROR_MAX_RETRIES) {
            errorRetries.current++;

            const delay =
                errorRetries.current === 1
                    ? ERROR_FIRST_TIMEOUT_RETRY
                    : ERROR_DEFAULT_TIMEOUT_RETRY;
            //must be null here to hide error dialog
            // @ts-ignore - suppress player error dialog
            player?.error(null);

            setTimeout(() => {
                if (player && !player.isDisposed()) {
                    player.src([{ src: videoSrc, type }]);
                    player.pause();
                    player.load();
                }
            }, delay);
        } else {
            onFail();
        }
    };

    return { handleRetryOnSrcError };
};
